export default __webpack_public_path__ + "static/media/item.b073bb28.png";